import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'pioneer-payment-rejection-reasons',
  templateUrl: './payment-rejection-reasons.component.html',
})
export class PaymentRejectionReasonsComponent implements OnInit {

  @Input() form: FormGroup;

  @Input() isHotelApprover: Boolean;

  reasons = [];

  constructor(
    private fb: FormBuilder,
    private translate: TranslateService,
  ) { }

  ngOnInit() {
    this.form.addControl('reason', this.fb.control('', Validators.required));
    this.form.addControl('description', this.fb.control(''));
    this.form.addControl('details', this.fb.control('', [Validators.required, Validators.maxLength(500)]));

    let commissionReasonText = 'EVENT.COMMISSION.REASON_COMMISSION';
    if (!this.isHotelApprover) {
      commissionReasonText = 'EVENT.COMMISSION.REASON_COMMISSION_AGENCY_APPROVE';
    }

    this.translate.get('EVENT.COMMISSION.REASON_ROOM_NIGHTS').subscribe(() => {
      this.reasons = [
        { value: 'option1', description: this.translate.instant('EVENT.COMMISSION.REASON_ROOM_NIGHTS') },
        { value: 'option2', description: this.translate.instant(commissionReasonText) },
        { value: 'option3', description: this.translate.instant('EVENT.COMMISSION.REASON_GUESTS') },
        { value: 'option4', description: this.translate.instant('EVENT.COMMISSION.REASON_OTHERS') },
      ];
    });

    this.reason.valueChanges.subscribe(val => {
      this.reasons.filter(reason => {
        if (reason.value === val) {
          this.description.setValue(reason.description);
        }
      });
    });
  }

  get reason() { return this.form.get('reason'); }
  get description() { return this.form.get('description'); }
  get details() { return this.form.get('details'); }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/payment-rejection-reasons/payment-rejection-reasons.component.ts